module.exports = __webpack_public_path__ + "img/crop-before.95926b5b.webp";